import { PhraseGroup, Phrase } from '@/models/phrases'

export interface PhrasesState {
  groups: PhraseGroup[]
  phrasesByGroup: Record<string, Phrase[] | undefined>
}

export const initialState: PhrasesState = {
  groups: [],
  phrasesByGroup: {},
}
